// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from "vue";
import $ from 'jquery';
import VueI18n from 'vue-i18n';



import {  
    UtilService, populateProductSpace,
    getURLParameter, loadsearchData
    //,encodeSpaceVersionKey
} from '../models/UtilService';

//import Papa from 'papaparse'; 
import { ViewportScrollInformations,ViewPortModus, Language, ProductSection, SpaceProperty } from '../models/ProductModels';
import { Log, ILogger } from '../models/Logger';
import { Viewport, ProductViewport, EmptyViewport, PartProductOverviewport, IndexViewport, getSpaceContentProperties } from '../models/Viewport';
import SearchComponent from '../components/SearchComponent.vue';
import LangDropdown from '../components/LangDropdown.vue';
import Modal from '../components/customs-components/Modal.vue';
import Tabs from '../components/customs-components/Tabs.vue';
import Message from '../components/customs-components/Message.vue';
import Tab from '../components/customs-components/Tab.vue';
import ProductSectionComponent from '../components/index-viewport-components/ProductSectionComponent.vue';
import ProductSubsectionComponent from '../components/index-viewport-components/ProductSubsectionComponent.vue';
import ProductAlphabeticalComponent from '../components/index-viewport-components/ProductAlphabeticalComponent.vue';
import VersionSelectDropdown from '../components/product-viewport-components/VersionSelectDropdown.vue';
import PartProductVersionSelectDropdown from '../components/partproduct-viewport-components/PartProductVersionSelectDropdown.vue';
import PartProductContent from '../components/partproduct-viewport-components/PartProductContent.vue';
import TreeItem from '../components/left-navigation/TreeItem.vue';
import RootEl from "../apps/test/RootEl.vue";
import Multipane from '../apps/test_resizable_boxes/resizable_components/Multipane.vue'
import MultipaneResizer from '../apps/test_resizable_boxes/resizable_components/MultipaneResizer.vue'
import { resolve } from 'path';
import VueRouter from 'vue-router';
import Grouped from './softbooks_views/Grouped';
import SoftbookProductPage from './softbooks_views/SoftbookProductPage';
import Startpage from './softbooks_views/Startpage';
import SoftbookSearchComponent from '@/components/SoftbookSearchComponent';
import SoftbooksSearchResultPage from './SoftbooksSearchResultPage.vue';
import SoftbookLangDropdown from '@/components/SoftbookLangDropdown';
import SoftbookServicePackPage from './softbooks_views/SoftbookServicePackPage';

  
Vue.config.productionTip = false
 

Vue.use(VueRouter);
Vue.use(VueI18n);


export const i18n = new VueI18n({
    locale:'de',
    fallbackLocale: 'de',
    messages:{
        de:{
            test:'DER TEST IN GERMAN',
            main_title:'BS2000 DOKUMENTATION',
            deutsch:'Deutsch',
            englisch:'Englisch',
            main_text:`Auf dieser Seite finden Sie alle Produktbereiche der Dokumentation zum BS2000. Wählen Sie den Produktlink, 
            um zur angegebenen Produktdokumentation zu gelangen, oder nutzen Sie das Feld "Suche nach Produkt", 
            um ein bestimmtes Produkt zu finden.`,
            prod_group:'Produktgruppen',
            prod_alpha:'Alphabetisch'
        },
        en:{
            test: 'THE TEST IN ENGLISCH',
            main_title:'BS2000 DOCUMENTATION',
            englisch:'English',
            deutsch:'German',
            main_text:`On this site you will find all product areas of documentation concerning BS2000. Choose the
            product
            link to get to the specified product documentation or use the "search for product" field to
            find
            a specific product`,
            prod_group:'Product Groups',
            prod_alpha:'Alphabetical'
        
        },
  
    }

});


const alphabetical = {template:'<div>AlphabetiCal Template</div>'};
const Products = {
    template: '<div>Product mit der ID: {{$route.params.id}}</div>'
}


const routes = 
[    
    {
        path:'/',
        redirect:'/de'
    },
    {
        path: '/:locale',
        name:'homepage',
        component:
        {
            template: '<router-view></router-view>'
        },
        beforeEnter(to, from , next){
            const lang = to.params.locale;

           // console.log('Inside Locale ',i18n.locale);
            

            if(!['en', 'de'].includes(lang))
            {
                return next('de');
            }
            if(i18n.locale !==lang){
                i18n.locale = lang;
            }

            return next();
        },
        children:[
        {path:'/',name:'startpage',component:Startpage},
        //{path:'',component:SoftbooksSearchResultPage},
        {path:'alphabetical',name:'alphabetical',component: Startpage},
        {path:'groupped-manuals',name:'grouped', component:Startpage},
        {path:'product/:id',name:'product',component:SoftbookProductPage},
        {path:'servicepack/:id',name:'servicepack',component:SoftbookServicePackPage},
        {path:'search/:searchterm',name:'search',component:SoftbooksSearchResultPage},
        {path:'*',name:'notfound',component:Startpage},
    ]
}
]
;

 
const router = new VueRouter({
    routes,
    base: 'SoftbooksIndex.html'
    //,mode:'history'

});


var viewPort = {viewportLanguage:Language.DE};
    
new Vue({
    i18n,
    router:router, 
    el: '#main-container',
    data: function () {
        return {
            currentUrl: window.location.hash,
            viewport: viewPort,
            navData: [],
            sections: [],
            prodStruct:{},
            homeHREF:this.$i18n.locale,
            isTabGruppedActiv:true,
            
        goHome(){
            this.$router.push(`/${i18n.locale}`);
            //return `${i18n.locale}`;
          //  return `{ name: 'homepage', params: { locale: '${this.$i18n.locale}' }}`;
        }
            }
    },
    beforeRouteUpdate (to, from, next) {
       // console.log('BEFORE ROUTE UPDATE ON MAIN CALLED');

        this.currentKey = this.$route.params.id;
        next();
        //console.log('BEFORE ROUTE UPDATE ON MAIN CALLED--> AFTER');
      },
      created(){
       // console.log('i18 in create: ',this.$i18n.locale);
      },
      
      computed:{
        currentLocale(){
            return this.$route.params.locale;
        },
        urif(){
            return `{ name: 'homepage', params: { locale: ${this.$i18n.locale} }}`;
        }
      },
  
    components: {
        'search': SoftbookSearchComponent ,
        'lang-dropdown': SoftbookLangDropdown
    },
   
});

function uri(){
    return `{ name: 'homepage', params: { locale: ${i18n.locale} }}`;
}


$(document).ready(function(){

   // $('table.handbooks-overview').addClass('table').addClass('table-striped table-bordered bs2-table-padding');
   // $('table.sp-products-overview').addClass('table').addClass('table-striped table-bordered bs2-table-padding');
/* CORRECT CONFLUENCE TABLE PROBLEME AND ACTIVATE TABLE SORTING */

$($('th').parent().parent()).each(function(){
	if ($(this).is('tbody')) {
		var th = $(this).find('th')
		if (th.length != $(this).find('tr:last-child td').length) {
			return
		}
		var tr = th.parent()
		tr.parents('table').prepend('<thead></thead>')
		tr.parents('table').find('thead').append(tr.detach())
	}
});



});

 